module.exports = __webpack_public_path__ + "img/contribute_2.3c86f541.png";